/** The help line: the keyboard's (`ui.help.keys`), or with the touch pad shown the touch gestures' (`ui.help.touch`). One line. */
import type { Strings } from '@ab/session';
import { text } from './text.ts';
import './ui.css';

export const KeyHelp = ({ strings, touch = false }: { readonly strings: Strings; readonly touch?: boolean }) => (
  <p className="ab-help" data-testid="help">
    {text(strings, touch ? 'ui.help.touch' : 'ui.help.keys')}
  </p>
);
